import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { ActionItemsActions } from ".";

import {
  CLEAR_ACTION_ITEM,
  CLEAR_ACTION_ITEM_STATE,
  FETCH_ACTION_ITEMS_LIST_FAILED,
  FETCH_ACTION_ITEMS_LIST_PROGRESS,
  FETCH_ACTION_ITEMS_LIST_SUCCESS,
  FETCH_ACTION_ITEM_FAILED,
  FETCH_ACTION_ITEM_PROGRESS,
  FETCH_ACTION_ITEM_SUCCESS,
} from "./actionItem.action";
import { initialActionItem, initialActionItemState } from "./actionItem.state";

export const actionItemReducer = (
  state: IStoreState["actionItems"] = initialActionItemState,
  action: ActionItemsActions
) => {
  switch (action.type) {
    case FETCH_ACTION_ITEMS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_ACTION_ITEMS_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = list;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_ACTION_ITEMS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_ACTION_ITEM_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.actionItem.loading = LoadState.InProgress;
        draftState.actionItem.data = initialActionItem;
      });
      return newState;
    }
    case FETCH_ACTION_ITEM_SUCCESS: {
      const { actionItem } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.actionItem.loading = LoadState.Loaded;
        draftState.actionItem.data = actionItem;
      });
      return newState;
    }
    case FETCH_ACTION_ITEM_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.actionItem.loading = LoadState.Failed;
        draftState.actionItem.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_ACTION_ITEM: {
      const newState = produce(state, (draftState) => {
        draftState.actionItem.loading = LoadState.NotLoaded;
        draftState.actionItem.data = initialActionItem;
      });
      return newState;
    }
    case CLEAR_ACTION_ITEM_STATE: {
      return initialActionItemState;
    }
    default: {
      return state;
    }
  }
};

